import React from 'react';
import { areEqual } from '../../util';
import { SearchIcon } from '../svgs';

function SearchInput({ value, onChange, placeholder, className, ariaLabel }) {
  return (
    <div className={`ar-column sp-input-col ${className}`}>
      <div className="bt-search">
        <div className="left" aria-hidden="true">
          <SearchIcon size={18} />
        </div>

        <div className="right search--wrapper">
          <input
            name="search"
            type="search"
            autoComplete="off"
            spellCheck={false}
            aria-label={ariaLabel ?? placeholder}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
          />
        </div>
      </div>
    </div>
  );
}
export default React.memo(SearchInput,areEqual)